import React from "react";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Zoom from "@material-ui/core/Zoom";
import DoneOutlineIcon from "@material-ui/icons/DoneOutline";
import { SketchPicker } from "react-color";
import Popover from "@material-ui/core/Popover";
import ErrorIcon from "@material-ui/icons/Error";
import { _post } from "../../Api";

const fontWeights = [500, 600, 700, 800, 900];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  select: {
    minWidth: 120,
    maxHeight: 40,
  },
  tableRow: {
    maxHeight: 60,
  },
  paper: {
    height: 30,
    width: 40,
  },
}));

export default function StylingSettings(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [articleBorder, setArticleBorder] = React.useState("");
  const [articleTextColour, setArticleTextColour] = React.useState("");
  const [articleBackgroundColour, setArticleBackgroundColour] = React.useState("");
  const [articleModifierColour, setArticleModifierColour] = React.useState("");
  const [articleModifierBorder, setArticleModifierBorder] = React.useState("");
  const [articleModifierBackgroundColour, setArticleModifierBackgroundColour] = React.useState("");
  const [articleFontWeight, setArticleFontWeight] = React.useState(500);

  const [tabTextColour, setTabTextColour] = React.useState("");
  const [tabSelectedTextColour, setSelectedTabTextColour] = React.useState("");
  const [tabFontWeight, setTabFontWeight] = React.useState(500);

  const [iFrame, setIFrame] = React.useState(false);
  const [accentColour, setAccentColour] = React.useState("");
  const [backgroundColour, setBackgroundColour] = React.useState("");
  const [textColour, setTextColour] = React.useState("");

  const [saving, setSaving] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentColourSelect, setCurrentColourSelect] = React.useState(null);
  const [error, setError] = React.useState(false);

  if (loading && !props.settings) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  } else if (props && loading) {
    setArticleBorder(props.settings.articles.border || "");
    setArticleTextColour(props.settings.articles.textColour || "");
    setArticleBackgroundColour(props.settings.articles.backgroundColour || "");
    setArticleModifierBackgroundColour(props.settings.articles.articleModiferBackgroundColour || "");
    setArticleModifierColour(props.settings.articles.articleModifierColour || "");
    setArticleModifierBorder(props.settings.articles.articleModiferBorder || "");
    setArticleFontWeight(props.settings.articles.fontWeight || 500);

    setTabTextColour(props.settings.tabs.textColour || "");
    setSelectedTabTextColour(props.settings.tabs.selectedTextColour || "");
    setTabFontWeight(props.settings.tabs.fontWeight || 500);

    setIFrame(props.settings.general.iFrame);
    setAccentColour(props.settings.general.accentColour || "");
    setBackgroundColour(props.settings.general.backgroundColour || "");
    setTextColour(props.settings.general.textColour || "");
    setLoading(false);
  }

  if (saving) {
    setTimeout(() => {
      setSaving(!saving);
    }, 1000);
    return (
      <Zoom in style={{ display: "flex", flexDirection: "column" }} timeout={{ enter: 500, exit: 300 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            flex: "1 1",
            alignItems: "center",
          }}
        >
          <DoneOutlineIcon />
        </div>
      </Zoom>
    );
  }

  if (error) {
    setTimeout(() => {
      setError(!error);
    }, 1000);
    return (
      <Zoom in style={{ display: "flex", flexDirection: "column" }} timeout={{ enter: 500, exit: 300 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            flex: "1 1",
            alignItems: "center",
          }}
        >
          <ErrorIcon />
        </div>
      </Zoom>
    );
  }

  const handleArticleBorder = (event) => {
    setArticleBorder(event.target.value);
  };

  const handleArticleTextColour = (event) => {
    setArticleTextColour(event.target.value);
  };

  const handleArticleBackgroundColour = (event) => {
    setArticleBackgroundColour(event.target.value);
  };

  const handleArticleModifierColour = (event) => {
    setArticleModifierColour(event.target.value);
  };

  const handleArticleModifierBorder = (event) => {
    setArticleModifierBorder(event.target.value);
  };

  const handleArticleModifierBackgroundColour = (event) => {
    setArticleModifierBackgroundColour(event.target.value);
  };

  const handleArticleFontWeight = (event) => {
    setArticleFontWeight(parseInt(event.target.value));
  };

  const handleTabTextColour = (event) => {
    setTabTextColour(event.target.value);
  };

  const handleTabSelectedTextColour = (event) => {
    setSelectedTabTextColour(event.target.value);
  };

  const handleTabFontWeight = (event) => {
    setTabFontWeight(parseInt(event.target.value));
  };

  const handleAccentColour = (event) => {
    setAccentColour(event.target.value);
  };

  const handleBackgroundColour = (event) => {
    setBackgroundColour(event.target.value);
  };

  const handleTextColour = (event) => {
    setTextColour(event.target.value);
  };

  const stylingObjectCreator = () => {
    return {
      backgroundColour,
      accentColour,
      iFrame,
      textColour,
      articles: {
        articleModifierBackgroundColour,
        articleModifierBorder,
        articleModifierColour,
        articleFontWeight,
        articleTextColour,
        articleBorder,
        articleBackgroundColour,
      },
      articleGroupsTabs: {
        tabTextColour,
        tabFontWeight,
        tabSelectedTextColour,
      },
    };
  };

  const handleSave = () => {
    _post("/nova/ta_merchant/styling/" + props.id, stylingObjectCreator())
      .then(() => {
        setSaving(true);
      })
      .catch((e) => {
        setError(true);
        console.log(e);
      });
  };

  const handleBackgroundColourPicker = (color) => {
    setCurrentColourSelect(color.hex);
    switch (currentColourSelect) {
      case "backgroundColour":
        setBackgroundColour(color.hex);
        break;
      case "articleBackgroundColour":
        setArticleBackgroundColour(color.hex);
        break;
      case "articleTextColour":
        setArticleTextColour(color.hex);
        break;
      case "articleModifierColour":
        setArticleModifierColour(color.hex);
        break;
      case "articleModifierBackgroundColour":
        setArticleModifierBackgroundColour(color.hex);
        break;
      case "tabTextColour":
        setTabTextColour(color.hex);
        break;
      case "tabSelectedTextColour":
        setSelectedTabTextColour(color.hex);
        break;
      case "accentColour":
        setAccentColour(color.hex);
        break;
      case "textColour":
        setTextColour(color.hex);
        break;
      default:
        return;
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColourSelect = (event, type) => {
    setCurrentColourSelect(type);
    setAnchorEl(event.currentTarget);
  };

  const handleKeyDown = (e) => {
    e.nativeEvent.stopImmediatePropagation();
  };

  const selectColour = Boolean(anchorEl);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={4} md={6} sm={12}>
          <Typography variant="h6">Articles</Typography>
          <Divider style={{ margin: 3 }} />
          <Grid container spacing={1}>
            <Grid item xs={6}>
              Border
            </Grid>
            <Grid item xs={6}>
              <TextField onKeyDown={handleKeyDown} value={articleBorder} onChange={handleArticleBorder} />
            </Grid>
            <Grid item xs={6}>
              Text colour
            </Grid>
            <Grid item xs={4}>
              <TextField onKeyDown={handleKeyDown} value={articleTextColour} onChange={handleArticleTextColour} />
            </Grid>
            <Grid item xs={2}>
              <Paper
                style={{ background: articleTextColour }}
                elevation={0}
                variant="outlined"
                className={classes.paper}
                onClick={(e) => handleColourSelect(e, "articleTextColour")}
              />
            </Grid>

            <Grid item xs={6}>
              Background colour
            </Grid>
            <Grid item xs={4}>
              <TextField
                onKeyDown={handleKeyDown}
                value={articleBackgroundColour}
                onChange={handleArticleBackgroundColour}
              />
            </Grid>
            <Grid item xs={2}>
              <Paper
                style={{ background: articleBackgroundColour }}
                elevation={0}
                variant="outlined"
                className={classes.paper}
                onClick={(e) => handleColourSelect(e, "articleBackgroundColour")}
              />
            </Grid>

            <Grid item xs={6}>
              Article modifier colour
            </Grid>
            <Grid item xs={4}>
              <TextField
                onKeyDown={handleKeyDown}
                value={articleModifierColour}
                onChange={handleArticleModifierColour}
              />
            </Grid>
            <Grid item xs={2}>
              <Paper
                style={{ background: articleModifierColour }}
                elevation={0}
                variant="outlined"
                className={classes.paper}
                onClick={(e) => handleColourSelect(e, "articleModifierColour")}
              />
            </Grid>

            <Grid item xs={6}>
              Article modifier border
            </Grid>
            <Grid item xs={6}>
              <TextField
                onKeyDown={handleKeyDown}
                value={articleModifierBorder}
                onChange={handleArticleModifierBorder}
              />
            </Grid>

            <Grid item xs={6}>
              Article modifier background color
            </Grid>
            <Grid item xs={4}>
              <TextField
                onKeyDown={handleKeyDown}
                value={articleModifierBackgroundColour}
                onChange={handleArticleModifierBackgroundColour}
              />
            </Grid>
            <Grid item xs={2}>
              <Paper
                style={{ background: articleModifierBackgroundColour }}
                elevation={0}
                variant="outlined"
                className={classes.paper}
                onClick={(e) => handleColourSelect(e, "articleModifierBackgroundColour")}
              />
            </Grid>

            <Grid item xs={10}>
              Font weight
            </Grid>
            <Grid item xs={2}>
              <Select onChange={handleArticleFontWeight} value={articleFontWeight}>
                {fontWeights.map((weight, i) => {
                  return (
                    <MenuItem key={i} value={weight}>
                      <Typography style={{ fontWeight: weight }}>{weight}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={4} md={6} sm={12}>
          <Typography variant="h6">Item Tabs</Typography>
          <Divider />

          <Grid container spacing={1}>
            <Grid item xs={6}>
              Text colour
            </Grid>
            <Grid item xs={4}>
              <TextField onKeyDown={handleKeyDown} value={tabTextColour} onChange={handleTabTextColour} />
            </Grid>
            <Grid item xs={2}>
              <Paper
                style={{ background: tabTextColour }}
                elevation={0}
                variant="outlined"
                className={classes.paper}
                onClick={(e) => handleColourSelect(e, "tabTextColour")}
              />
            </Grid>

            <Grid item xs={6}>
              Selected text colour
            </Grid>
            <Grid item xs={4}>
              <TextField
                onKeyDown={handleKeyDown}
                value={tabSelectedTextColour}
                onChange={handleTabSelectedTextColour}
              />
            </Grid>
            <Grid item xs={2}>
              <Paper
                style={{ background: tabSelectedTextColour }}
                elevation={0}
                variant="outlined"
                className={classes.paper}
                onClick={(e) => handleColourSelect(e, "tabSelectedTextColour")}
              />
            </Grid>

            <Grid item xs={10}>
              Font weight
            </Grid>
            <Grid item xs={2}>
              <Select onChange={handleTabFontWeight} value={tabFontWeight}>
                {fontWeights.map((weight, i) => {
                  return (
                    <MenuItem key={i} value={weight}>
                      <Typography style={{ fontWeight: weight }}>{weight}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          lg={4}
          md={6}
          sm={12}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flex: "1 1",
          }}
        >
          <div>
            <Typography variant="h6">General</Typography>
            <Divider />
            <Grid container spacing={1}>
              <Grid item xs={10}>
                iFrame
              </Grid>
              <Grid item xs={2}>
                <Switch checked={iFrame} onChange={() => setIFrame(!iFrame)} size="small" color="primary" />
              </Grid>

              <Grid item xs={6}>
                Accent colour
              </Grid>
              <Grid item xs={4}>
                <TextField onKeyDown={handleKeyDown} value={accentColour} onChange={handleAccentColour} />
              </Grid>
              <Grid item xs={2}>
                <Paper
                  onKeyDown={handleKeyDown}
                  style={{ background: accentColour }}
                  elevation={0}
                  variant="outlined"
                  className={classes.paper}
                  onClick={(e) => handleColourSelect(e, "accentColour")}
                />
              </Grid>

              <Grid item xs={6}>
                Background colour
              </Grid>
              <Grid item xs={4}>
                <TextField onKeyDown={handleKeyDown} value={backgroundColour} onChange={handleBackgroundColour} />
              </Grid>
              <Grid item xs={2}>
                <Paper
                  style={{ background: backgroundColour }}
                  elevation={0}
                  variant="outlined"
                  className={classes.paper}
                  onClick={(e) => handleColourSelect(e, "backgroundColour")}
                />
              </Grid>

              <Grid item xs={6}>
                Text colour
              </Grid>
              <Grid item xs={4}>
                <TextField onKeyDown={handleKeyDown} value={textColour} onChange={handleTextColour} />
              </Grid>
              <Grid item xs={2}>
                <Paper
                  style={{ background: textColour }}
                  elevation={0}
                  variant="outlined"
                  className={classes.paper}
                  onClick={(e) => handleColourSelect(e, "textColour")}
                />
              </Grid>
            </Grid>
          </div>

          <Button onClick={handleSave}>Save</Button>
        </Grid>

        <Popover
          open={selectColour}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <SketchPicker color={currentColourSelect} onChange={handleBackgroundColourPicker} />
        </Popover>
      </Grid>
    </div>
  );
}
